// Shared time-based broadcast status helpers so ScheduleListItem, waiting page,
// and ended page all agree on the same classification.
//
// Rules (Asia/Seoul reference — but since Date arithmetic is timezone-independent
// once parsed from ISO, we compare in local wall clock time by default which is
// already Asia/Seoul on the target platform).

const DEFAULT_DURATION_MINUTES = 60;

/**
 * Return one of: 'before' | 'live' | 'ended'.
 */
export const getBroadcastPhase = (live, now = new Date()) => {
  if (!live?.scheduled_at) return 'before';
  const start = new Date(live.scheduled_at);
  const end = live.end_at
    ? new Date(live.end_at)
    : new Date(start.getTime() + (Number(live.duration_minutes || live.duration) || DEFAULT_DURATION_MINUTES) * 60 * 1000);
  // Explicit status trumps time when the seller/admin marked it ended.
  if (['종료', 'ended', '취소', 'cancelled'].includes(live.status)) return 'ended';
  if (now < start) return 'before';
  if (now >= end) return 'ended';
  return 'live';
};

export const getWatchButtonLabel = (phase) => {
  if (phase === 'live') return '방송 보기';
  if (phase === 'ended') return '종료됨';
  return '방송 전';
};

export default { getBroadcastPhase, getWatchButtonLabel };
